import styled from "styled-components";

export const Component = styled.i`
  padding: 0px 4px;
`;
